import React from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const CustomizedTick = ({ x, y, payload }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={5} // Adjust vertical alignment
                textAnchor="end" // Align the text properly
                transform="rotate(270)" // Rotate the text by 90 degrees
                fill="#616161"
                style={{ fontSize: "14px" }}
            >
                {payload.value}
            </text>
        </g>
    );
};

function CustomLineChart({ data, color }) {

    function addValuesToObjects(array) {
        return array?.map((item) => ({
            ...item,
            value_95: 95,
            value_70: 70,
            value_60: 60,
        }));
    }
    const updatedData = addValuesToObjects(data);


    const calculateYRange = (data, keys) => {
        let min = Infinity;
        let max = -Infinity;

        data?.forEach((item) => {
            keys.forEach((key) => {
                if (item[key] !== undefined) {
                    min = Math.min(min, item[key]);
                    max = Math.max(max, item[key]);
                }
            });
        });

        const roundUpToNearest5 = (value) => Math.ceil(value / 25) * 25
        min = roundUpToNearest5(min - 2)
        max = 100//roundUpToNearest5(max + 2)
        return { min, max };
    };

    const yRange = calculateYRange(updatedData, [
        'averageValue',
        'value_95',
        'value_70',
        'value_60',
    ]);

    const generateTicks = (min, max, step) => {
        const ticks = [];
        for (let i = min; i <= max; i += step) {
            ticks.push(i);
        }
        const additionalTicks = [60, 70, 95]
        const mergedTicks = Array.from(new Set([...ticks, ...additionalTicks]));
        return mergedTicks.sort((a, b) => a - b);
    };

    const yTicks = generateTicks(yRange.min, yRange.max, 25);

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10, border: '1px solid #ccc', borderRadius: '5px' }}>
                    <div style={{ color: "#33ABDA", fontWeight: "700%" }}><span style={{ color: "grey" }}>{`${payload[0]['payload']['yearMonth']}`}</span> : {`${payload[0]['payload']['averageValue']}`}</div>

                </div>
            );
        }

        return null;
    };

    return (
        <ResponsiveContainer width="100%" height={300}>
            <LineChart
                width={"100%"}
                height={"100%"}
                data={updatedData}
                margin={{
                    top: 20,
                    right: 10,
                    left: -20,
                    bottom: 30,
                }}
            >
                <CartesianGrid horizontal={true} vertical={true} stroke='#DFDFDF' />
                <XAxis dataKey="yearMonth" tickLine={false} tick={<CustomizedTick />} interval={0} />
                <YAxis axisLine={false} tickLine={false} domain={[yRange.min, yRange.max]} ticks={yTicks} interval={0} tickFormatter={(value) => `${value}%`} />
                <Line type="linear" dataKey="averageValue" stroke={color} dot={false} strokeWidth={5} />
                <Line type="linear" dataKey="value_95" stroke={"#006A42"} dot={false} strokeWidth={3} activeDot={false} />
                <Line type="linear" dataKey="value_70" stroke={"#FFCC49"} dot={false} strokeWidth={3} activeDot={false} />
                <Line type="linear" dataKey="value_60" stroke={"#AA001A"} dot={false} strokeWidth={3} activeDot={false} />
                <Tooltip content={<CustomTooltip />} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default CustomLineChart
